import { call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify'; 

import ApiFinancialYTD from '../../Api/ApiFinancialYTD';
import ToastMsg from '../../Components/ToastMsg';
import { creators as FinancialYTDActions } from '../../Reducers/Reporting/FinancialYTD';

export function* getFinancialYTDSummary({ payload }) {
  try {
    const response = yield call(
      ApiFinancialYTD.getSummary,
      payload.selectedMonths,
    );

    if (response.status === 200) {
      yield put(FinancialYTDActions.fytdSuccess({ summaryData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Financial YTD Summary',
            text: response.message,
          },
        },
      );
      yield put(FinancialYTDActions.fytdFailure(response.message));
    }
  } catch (e) {
    yield put(FinancialYTDActions.fytdFailure(e));
  }
}

export function* getFinancialYTDDetail({ payload }) {
  try {
    const response = yield call(
      ApiFinancialYTD.getDetail,
      payload.selectedYearMonth,
    );

    if (response.status === 200) {
      yield put(FinancialYTDActions.fytdSuccess({ detailData: response.data }));
    } else {
      if (response.status !== 401) toast.error(ToastMsg,
        {
          data: {
            title: 'Financial YTD Detail',
            text: response.message,
          },
        },
      );
      yield put(FinancialYTDActions.fytdFailure(response.message));
    }
  } catch (e) {
    yield put(FinancialYTDActions.fytdFailure(e));
  }
}
